export enum ShareType {
    facebook,
    twitter,
    linkedin
}